import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import authApi from '../../api/authApi';
import './Home.css'; 

const Home = () => {
    const [auth, setAuth] = useState(false);
    const [message, setMessage] = useState('');
    const [name, setName] = useState('');

    useEffect(() => {
        const fetchAuthStatus = async () => {
            try {
                const response = await authApi.checkAuth();
                if (response.data.status === 'success') {
                    setAuth(true);
                    setName(response.data.name);
                } else {
                    setAuth(false);
                    setMessage(response.data.error);
                }
            } catch (error) {
                console.error('Ошибка при проверке авторизации:', error);
                setAuth(false);
                setMessage('Произошла ошибка. Попробуйте позже.');
            }
        };

        fetchAuthStatus();
    }, []);

    const handleLogout = async () => {
        try {
            await authApi.logout();
            window.location.reload();
        } catch (error) {
            console.error('Ошибка при выходе из системы:', error);
        }
    };

    return (
        <div className="home-container">
            <div className="home-content">
                {
                    auth ? (
                        <div className="auth-message">
                            <h2 className="greeting">Welcome back, {name}!</h2>
                            <button className="btn-logout" onClick={handleLogout}>Logout</button>
                        </div>
                    ) : (
                        <div className="login-message">
                            <h2 className="error-message">{message || 'Please log in to continue'}</h2>
                            <Link to="/login" className="btn-login">Login</Link>
                        </div>
                    )
                }
                <h2 className="home-title">Welcome to the Home Page!</h2>
                <p className="routes-description">Here are all the available routes:</p>
                <ul className="routes-list">
                    <li>
                        <Link to="/" className="btn btn-info">Home</Link>
                    </li>
                    <li>
                        <Link to="/login" className="btn btn-info">Login</Link>
                    </li>
                    <li>
                        <Link to="/register" className="btn btn-info">Register</Link>
                    </li>
                    <li>
                        <Link to="/chat" className="btn btn-info">Chat</Link>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default Home;
